import {
  HISTORICAL_DATA_SUCCESS,
  HISTORICAL_DATA_FAILED,
} from "../Actions/types";

const INITIAL_STATE = {
  data: {},
  error: {},
};

const historicalDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case HISTORICAL_DATA_SUCCESS:
    return { ...state, data: action.payload };
  case HISTORICAL_DATA_FAILED:
    return { ...state, error: action.payload };
  default:
    return { ...INITIAL_STATE };
  }
};

export default historicalDataReducer;
